import { Box, Paper, Typography } from "@mui/material";
import { globalStyles } from "../styles/GlobalStyles";
import { useState } from "react";
import VerifyOtpForm from "../modules/authModule/components/VerifyOtpForm";
import ResetPasswordForm from "../modules/authModule/components/ResetPasswordForm";
import SetAccountPasswordForm from "../modules/authModule/components/SetAccountPasswordForm";
import Button from "../components/Button";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState<string>();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [completeType, setCompleteType] = useState<string>();

  const isSuccess = completeType === "SUCCESS";

  const navigate = useNavigate();

  function renderForm() {
    if (!isOtpSent) {
      return (
        <ResetPasswordForm
          onSuccess={(val) => {
            setEmail(val);
            setIsOtpSent(true);
          }}
        />
      );
    }
    if (!isOtpVerified) {
      return (
        <VerifyOtpForm email={email} onSuccess={() => setIsOtpVerified(true)} />
      );
    }
    if (completeType) {
      return (
        <>
          <Typography textTransform="capitalize" fontWeight={700} variant="h5">
            {isSuccess
              ? t("Password_Change_Success_Heading")
              : t("Password_Change_Error_Heading")}
          </Typography>
          <Typography mt={1} mb={3}>
            {isSuccess
              ? t("Password_Change_Success_Desc")
              : t("Password_Change_Error_Desc")}
          </Typography>
          <Button
            onClick={() => navigate(-1)}
            fullWidth
            sx={{
              textTransform: "none",
              fontSize: 16,
              color: "custom.foreground.secondary",
            }}
          >
            {t("Back_to_Login")}
          </Button>
        </>
      );
    }
    return (
      <SetAccountPasswordForm
        email={email}
        onSuccess={() => setCompleteType("SUCCESS")}
        onError={() => setCompleteType("ERROR")}
      />
    );
  }

  return (
    <Box sx={globalStyles.colCenter}>
      <Paper
        sx={{
          padding: 4,
          width: 412,
          borderRadius: 4,
        }}
      >
        {renderForm()}
      </Paper>
    </Box>
  );
};

export default ResetPassword;
